import {
  HStack,
  Button,
  Tooltip,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Box,
  Text,
  useDisclosure,
  Portal,
  ListItem,
  UnorderedList,
  Link,
  Spinner,
  Image,
  Icon,
} from "@chakra-ui/react";
import {
  PersonOutlineOutlined,
  AltRoute,
  SwapHoriz,
} from "@mui/icons-material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { BsThreeDots } from "react-icons/bs";
import {
  FaHourglassHalf,
  FaRegPauseCircle,
  FaRegPlayCircle,
  FaPlay,
  FaStop,
  FaTimes,
  FaTruck,
  FaRupeeSign,
} from "react-icons/fa";
import { FiAlertTriangle } from "react-icons/fi";
import CheckIcon from "@mui/icons-material/Check";
import { GiCardExchange, GiCrownedSkull, GiReturnArrow } from "react-icons/gi";
import { GrUpload } from "react-icons/gr";
import { RiMenuAddFill } from "react-icons/ri";
import GaraazAlertDialogue from "../../../components/GaraazAlertDialogue";
import TextInputModal from "../../../components/TextInputModal";
import services from "../services";
import useNotification, {
  useGaraazToastWithChildren,
} from "../../../utils/useNotification";
import { useOrdersStore } from "../store/useOrdersStore";
import {
  OrderStatus,
  OrderActions,
  OrdersTextLabels,
  OrderPopoverLabels,
} from "../enums";
import GaraazChoser from "./GaraazChoser";
import GaraazDatePickerModalETA from "./GaraazDatePickerModalETA";
import OrderCancellationModal from "./OrderCancellationModal";
import OrderMergeModal from "./OrderMergeModal";
import OrderReturnModal from "./OrderReturnModal";
import OrderSplitModal from "./OrderSplitModal";
import UploadInvoiceModal, { invoiceInfoType } from "./UploadInvoiceModal";
import { useGetOrderMediaConfig } from "../../PlaceOrderTest/queryHooks";
import { useGetAllSuppliers, useGetSingleGaraazOrder } from "../queryHooks";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import { AllocatedTo, startOrcaStates } from "./GaraazOrderComponent";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import CallMergeIcon from "@mui/icons-material/CallMerge";
import DeleteIcon from "@mui/icons-material/Delete";
import OrderStatusChangeErrorBox from "./OrderStatusChangeErrorBox";
import { useUserDetailsContext } from "../../../context/userDetailsContext";
import GaraazCountDownClockV2 from "./GaraazCountDownClockV2";
import InvoicePopver from "./InvoicePopover";
import ReactCanvasConfetti from "react-canvas-confetti";
import {
  dateFormatInvoiceApi,
  getCurrentUTCTimestamp,
} from "../../../utils/dateResolvers";
import GarrazCopyText from "./GaraazCopyText";
import GaraazErrorDialogue from "../../../components/GaraazErrorDialogue";
import getUserRole from "../../../utils/getUserRole";
import constants, { META_INFO_KEYS } from "../../../utils/constants";
import { NavLink, useNavigate } from "react-router-dom";
import paths from "../../../utils/paths";
import { Roles } from "../enums";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import InvoicePopoverTrigger from "../../../components/InvoicePopoverTrigger";
import { redirectToOrderPage } from "../../../utils/redirectToOrderPage";
import { GaraazInfoPopover } from "@svan-garaaz/reactsharedlib";
import GaraazInfoDialogue from "../../../components/GaraazInfoDialogue";
import SupplierInventorySearch from "../../../components/SupplierInventorySearch/SupplierInventorySearch";
import TransactionTypeSelectComponent from "../../../components/TransactionTypeSelectComponent";
import updateOrderHandlerAllocationTime from "../../../utils/updateOrderHandlerAllocationTime";
import updateAckTime from "../../../utils/updateAckTime";
import { OrderRelationType } from "../store/orderStrategies";
import { useAssignSupplier } from "../hooks/useAssignSupplier";
import { useExecuteSupplierBucket } from "../hooks/useExecuteSupplierBucket";
import { changeParticipantInConversation } from "../../../utils/conversationUtils";
import {
  buildPartsPayloadForDeliveryOptions,
  EnrichedSupplierForDelivery,
  NormalizedDeliverySelection,
} from "../../../components/DeliveryOptions";
import {
  GaraazCollectPaymentModal,
  CollectedBy,
  PaymentMode,
  InvoiceType,
} from "@svan-garaaz/reactsharedlib";
import { InvoiceInfo, hasSupplierInvoice } from "../orderUtils";
import { PaymentCollectionDetail } from "../types";
import {
  GetOrderLabels,
  useOrderLabel,
} from "./GaraazOrderCard/OrderLabelContext";

export enum PartConversionState {
  NOT_STARTED = "not_started",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
}

export type GaraazOrderComponentFooterProps = {
  orderData: any;
  orderStatus: any;
  orderCancellationReason: string[];
  setOrderStatus: React.Dispatch<any>;
  handlePartConversionChangeScreen: () => void;
  activesupplierOrderStatus: AllocatedTo;
  refetchAllOrders: () => void;
  setEtaMissed: React.Dispatch<React.SetStateAction<boolean>>;
  isCustomerOrderFreezed: boolean;
  garaazRemarks: string;
  setGaraazRemarks: React.Dispatch<React.SetStateAction<string>>;
  supplierCancellationReasons: string;
  setSupplierCancellationReasons: React.Dispatch<React.SetStateAction<string>>;
  customerHoldReasons: string;
  setCustomerHoldReasons: React.Dispatch<React.SetStateAction<string>>;
  promiseTimeBreachReasons: string;
  setPromiseTimeBreachReasons: React.Dispatch<React.SetStateAction<string>>;
  setTransactionType: React.Dispatch<React.SetStateAction<string>>;
  isChildOrdersVisible?: boolean;
  isLoadingChildOrders?: boolean;
  isChildOrder?: boolean;
};

const GaraazOrderComponentFooter: React.FC<GaraazOrderComponentFooterProps> = ({
  orderData,
  orderStatus,
  handlePartConversionChangeScreen,
  activesupplierOrderStatus,
  refetchAllOrders,
  orderCancellationReason,
  setOrderStatus,
  setEtaMissed,
  isCustomerOrderFreezed,
  garaazRemarks,
  setGaraazRemarks,
  supplierCancellationReasons,
  setSupplierCancellationReasons,
  customerHoldReasons,
  setCustomerHoldReasons,
  promiseTimeBreachReasons,
  setPromiseTimeBreachReasons,
  setTransactionType,
  isChildOrdersVisible = false,
  isChildOrder = false,
}) => {
  const toast = useNotification();
  const {
    orderLabel,
    isEnquiryOrder,
  }: { orderLabel: GetOrderLabels; isEnquiryOrder: boolean } = useOrderLabel();
  const navigate = useNavigate();
  const garaazToast = useGaraazToastWithChildren();
  const userDetails = useUserDetailsContext();
  const role = getUserRole(userDetails);
  const authorizationAPItoken = useMemo(
    () => localStorage.getItem(constants.AUTH_TOKEN) || "",
    [],
  );

  const orderEta = useOrdersStore(
    useCallback((state) => state.orderEtas[orderData._id], [orderData._id]),
  );
  const setSelectedOrderHandler = useOrdersStore(
    useCallback((store) => store.setSelectedOrderHandler, []),
  );
  const setOrderEtasWithOrderId = useOrdersStore(
    useCallback((state) => state.setOrderEtasWithOrderId, []),
  );
  const savedOrderRemarks = useOrdersStore(
    useCallback((state) => state.orderRemarks[orderData._id], [orderData._id]),
  );
  const setSavedOrderRemarks = useOrdersStore(
    useCallback((state) => state.setOrderRemarksWithOrderId, []),
  );
  const orderHandlers = useOrdersStore(
    useCallback((state) => state.orderHandlers, []),
  );
  const orderItems = useOrdersStore(
    useCallback((state) => state.orderItems[orderData._id], [orderData._id]),
  );
  const setOrderMetaInfoWithOrderId = useOrdersStore(
    (state) => state.setOrderMetaInfoWithOrderId,
  );

  const orderItemsPayloadForDeliveryOptions = useMemo(() => {
    const supplierParts =
      orderItems?.map((item: any) => ({
        rootPartNumber: item.rootPartNumber,
        allocatedQuantity: item.orderedQuantity,
      })) || [];
    return buildPartsPayloadForDeliveryOptions(supplierParts, orderItems || []);
  }, [orderItems]);

  const [discount, setDiscount] = useState(orderData?.discount || "");
  const [creditNotePercentage, setCreditNotePercentage] = useState(
    orderData?.creditNotePercentage || "",
  );
  const [isTradingModalOpen, setIsTradingModalOpen] = useState(false);
  const [isChangeTransactionTypeOpen, setIsChangeTransactionTypeOpen] =
    useState(false);

  const isAllowedToChangeTransactionType = useMemo(
    () =>
      userDetails.userSubType === Roles.HEAD_OF_OPERATIONS &&
      Boolean(activesupplierOrderStatus?.supplierId) &&
      orderStatus !== OrderStatus.DISPATCHED &&
      orderStatus !== OrderStatus.DELIVERED,
    [
      userDetails.userSubType,
      activesupplierOrderStatus?.supplierId,
      orderStatus,
    ],
  );

  const [isPartConversionActive, setIsPartConversionActive] = useState(false);
  const [isSupplierAllocationInProgress, setIsSupplierAllocationInProgress] =
    useState(false);

  const { data: mobileConfigs } = useGetOrderMediaConfig();
  const { data: allSuppliers } = useGetAllSuppliers();
  const { data: parentOrder } = useGetSingleGaraazOrder(
    orderData.parentOrderId,
  ) as any;
  const hasEnquiryRoot =
    orderData?.rootOrderId && orderData.rootOrderId !== orderData._id;
  const { data: enquiryOrder } = useGetSingleGaraazOrder(
    orderData.rootOrderId ?? "",
    { enabled: !!hasEnquiryRoot },
  );

  const { data: currentOrder, refetch: refetchCurrentOrder } =
    useGetSingleGaraazOrder(orderData._id);

  const [paymentCollectionDetail, setPaymentCollectionDetail] =
    useState<PaymentCollectionDetail | null>(null);
  const [isCollectPaymentModalOpen, setIsCollectPaymentModalOpen] =
    useState(false);

  const handleOpenCollectPaymentModal = (
    orderNo: string,
    invoiceInfo: InvoiceInfo,
    customerAdvancePayment: number,
    invoiceType?: InvoiceType,
  ) => {
    setPaymentCollectionDetail((prevPaymentCollectionDetail) => {
      const baseState = {
        ...(prevPaymentCollectionDetail ?? {}),
        orderNo,
        invoiceNo: invoiceInfo?.invoiceNo,
        invoiceAmount: invoiceInfo?.balanceAmount ?? invoiceInfo?.invoiceAmount,
        customerAdvancePayment,
      };
      if (invoiceType === InvoiceType.DELIVERY) {
        return {
          ...baseState,
          invoiceType: InvoiceType.DELIVERY,
        };
      } else {
        // Explicitly omit invoiceType if not DELIVERY
        const { invoiceType: _omit, ...stateWithoutInvoiceType } = baseState;
        return stateWithoutInvoiceType;
      }
    });
    return setIsCollectPaymentModalOpen(true);
  };

  const handleCloseCollectPaymentModal = useCallback(() => {
    setIsCollectPaymentModalOpen(false);
  }, []);

  const [samePartNumberOrders, setSamePartNumberOrders] = useState<any[]>([]);
  const reviewSamePartOrdersLinkRef = useRef<any>(null);
  const [isSamePartNumberOrdersLoading, setIsSamePartNumberOrdersLoading] =
    useState(false);
  const [invoiceInfo, setInvoiceInfo] = useState({
    title: "Garaaz",
    invoiceType: "ORDER" as const,
    invoiceMediaId: orderData?.invoiceInfo?.invoiceMediaId ?? "",
    mrpInvoiceMediaId: orderData?.invoiceInfo?.mrpInvoiceMediaId ?? "",
    invoiceNo: orderData?.invoiceInfo?.invoiceNo ?? "",
    invoiceAmount: orderData?.invoiceInfo?.invoiceAmount ?? "",
    outstanding: orderData?.invoiceInfo?.balanceAmount ?? "",
    invoiceDate: orderData?.invoiceInfo?.invoiceDate ?? "",
    invoiceStatus: orderData?.invoiceInfo?.invoiceStatus ?? "",
    paymentLink: orderData?.invoiceInfo?.paymentLink ?? "",
  });

  const [deliveryInvoiceInfo, setDeliveryInvoiceInfo] = useState({
    title: "Delivery",
    invoiceType: "DELIVERY" as const,
    invoiceMediaId: orderData?.deliveryInfo?.invoiceMediaId ?? "",
    invoiceNo: orderData?.deliveryInfo?.invoiceNo ?? "",
    invoiceAmount: orderData?.deliveryInfo?.invoiceAmount ?? "",
    outstanding: orderData?.deliveryInfo?.balanceAmount ?? "",
    invoiceDate: orderData?.deliveryInfo?.invoiceDate ?? "",
    invoiceStatus: orderData?.deliveryInfo?.invoiceStatus ?? "",
    paymentLink: orderData?.deliveryInfo?.paymentLink ?? "",
  });

  const [challanInfo, setChallanInfo] = useState({
    title: "Garaaz",
    challanMediaId: orderData?.challanInfo?.challanMediaId ?? "",
    challanNo: orderData?.challanInfo?.challanNo ?? "",
    challanAmount: orderData?.challanInfo?.challanAmount ?? "",
    challanDate: orderData?.challanInfo?.challanDate ?? "",
  });
  const [supplierInvoiceInfo, setSupplierInvoiceInfo] = useState<
    {
      invoiceMediaId: any;
      invoiceNo: any;
      invoiceAmount: any;
      invoiceDate: any;
    }[]
  >(orderData.allocatedTo?.map((item: any) => item.invoiceInfo));
  const [supplierChallanInfo, setSupplierChallanInfo] = useState<
    {
      challanMediaId: any;
      challanNo: any;
      challanAmount: any;
      challanDate: any;
    }[]
  >(orderData.allocatedTo?.map((item: any) => item.challanInfo));
  const [ackClockValue0, setAckClockValue0] = useState(
    Math.floor(new Date(orderData.orderDate).getTime() / 1000),
  );

  const [ackClockValue100, setAckClockValue100] = useState(
    Math.floor(new Date(orderData.orderDate).getTime() / 1000) +
      mobileConfigs?.threshold_ack_order_mins * 60,
  );
  const [assignedSupplier, setAssignedSupplier] = useState<AllocatedTo[]>(
    orderData?.allocatedTo || [],
  );

  const [cancellationReason, setCancellationReason] = useState(
    orderData?.cancellationReason ?? "",
  );
  const [returnOrders, setReturnOrders] = useState<any>([]);
  const [CBOOrders, setCBOOrders] = useState<any>([]);
  const [ackTimeMissed, setAckTimeMissed] = useState(false);
  const [parentOrderActiveSupplier, setParentOrderActiveSupplier] =
    useState<any>(null);

  const [filteredSuppliers, setFilteredSuppliers] = useState(allSuppliers);

  const orderHandlerOptions = orderHandlers.map((orderHandler) => {
    return {
      name: orderHandler.user.firstName + " " + orderHandler.user.lastName,
      menuItemIcon: (
        <Brightness1Icon
          sx={{
            color: orderHandler?.isActive ? "green" : "red",
            fontSize: "10px",
          }}
        />
      ),
      ...orderHandler,
    };
  });
  const orderHandlerName =
    (orderData?.orderHandler[0]?.firstName ?? "-") +
    " " +
    (orderData?.orderHandler[0]?.lastName ?? "");
  const transactionTypeOption = [{ type: "Facilitation" }, { type: "Trading" }];

  const {
    isOpen: etaPickerModalOpen,
    onOpen: openETAPickerModal,
    onClose: closeETAPickerModal,
  } = useDisclosure();

  const {
    isOpen: updateInvoiceModalOpen,
    onOpen: openUpdateInvoiceModal,
    onClose: closeUpdateInvoiceModal,
  } = useDisclosure();

  const {
    isOpen: orderRemarksModelOpen,
    onOpen: openOrdersRemarksModel,
    onClose: closeOrdersRemarksModel,
  } = useDisclosure();

  const {
    isOpen: isOpenCBOOrderDialogue,
    onOpen: onOpenCBOOrderDialogue,
    onClose: onCloseCBOOrderDialogue,
  } = useDisclosure();

  const {
    isOpen: isOpenREADY_TO_DISPATCHOrderDialogue,
    onOpen: onOpenREADY_TO_DISPATCHOrderDialogue,
    onClose: onCloseREADY_TO_DISPATCHOrderDialogue,
  } = useDisclosure();

  const {
    isOpen: isOpenLossOrderDialogue,
    onOpen: onOpenLossOrderDialogue,
    onClose: onCloseLossOrderDialogue,
  } = useDisclosure();

  const {
    isOpen: isOpenCUSTOMER_HOLDOrderDialogue,
    onOpen: onOpenCUSTOMER_HOLDOrderDialogue,
    onClose: onCloseCUSTOMER_HOLDOrderDialogue,
  } = useDisclosure();

  const {
    isOpen: isOpenSamePartNumberFoundInOtherOrderDialogue,
    onOpen: onOpenSamePartNumberFoundInOtherOrderDialogue,
    onClose: onCloseSamePartNumberFoundInOtherOrderDialogue,
  } = useDisclosure();

  const {
    isOpen: isReturnOrderModalOpen,
    onOpen: onOpenReturnModal,
    onClose: onCloseReturnModal,
  } = useDisclosure();

  const {
    isOpen: orderCancellationReasonModalOpen,
    onOpen: openOrderCancellationReasonModal,
    onClose: closeOrderCancellationReasonModal,
  } = useDisclosure();
  const {
    isOpen: isOrderMergeModalOpen,
    onOpen: onOpenOrderMergeModal,
    onClose: onCloseOrderMergeModal,
  } = useDisclosure();
  const {
    isOpen: isOrderSplitModalOpen,
    onOpen: onOpenOrderSplitModal,
    onClose: onCloseOrderSplitModal,
  } = useDisclosure();
  const {
    isOpen: orderDeletionReasonModalOpen,
    onOpen: openOrderDeletionReasonModal,
    onClose: closeOrderDeletionReasonModal,
  } = useDisclosure();

  const {
    isOpen: isSupplierInventorySearchModalOpen,
    onOpen: onSupplierInventorySearchModalOpen,
    onClose: onSupplierInventorySearchModalClose,
  } = useDisclosure();

  const {
    isOpen: isOrderDetailsExtractedByPhantomModalOpen,
    onOpen: onOrderDetailsExtractedByPhantomModalOpen,
    onClose: onOrderDetailsExtractedByPhantomModalClose,
  } = useDisclosure();

  const refAnimationInstance: any = useRef(null);

  const getInstance = useCallback((instance: any) => {
    refAnimationInstance.current = instance;
  }, []);

  const makeShot = useCallback((particleRatio: any, opts: any) => {
    if (refAnimationInstance.current) {
      refAnimationInstance.current({
        ...opts,
        particleCount: Math.floor(1000 * particleRatio),
      });
    }
  }, []);

  const fire = useCallback(() => {
    makeShot(2, {
      spread: 360,
      angle: 90,
      startVelocity: 70,
      gravity: 0.5,
    });
  }, [makeShot]);

  const assignSupplierHook = useAssignSupplier({
    orderId: orderData._id,
    orderData,
    orderItems,
    setOrderMetaInfoWithOrderId,
    setAssignedSupplier,
    refetchAllOrders,
    supplierName: "",
    isCustomerOrderFreezed,
  });

  const executeSupplierBucketHook = useExecuteSupplierBucket({
    orderId: orderData._id,
    orderData,
    orderItems,
    setOrderMetaInfoWithOrderId,
    refetchAllOrders,
    isCustomerOrderFreezed,
  });

  useEffect(() => {
    setInvoiceInfo({
      title: "Garaaz",
      invoiceType: "ORDER" as const,
      invoiceMediaId: orderData?.invoiceInfo?.invoiceMediaId,
      mrpInvoiceMediaId: orderData?.invoiceInfo?.mrpInvoiceMediaId,
      invoiceNo: orderData?.invoiceInfo?.invoiceNo,
      invoiceDate: orderData?.invoiceInfo?.invoiceDate,
      invoiceAmount: orderData?.invoiceInfo?.invoiceAmount,
      outstanding: orderData?.invoiceInfo?.balanceAmount,
      invoiceStatus: orderData?.invoiceInfo?.invoiceStatus,
      paymentLink: orderData?.invoiceInfo?.paymentLink,
    });

    setDeliveryInvoiceInfo({
      title: "Delivery",
      invoiceType: "DELIVERY" as const,
      invoiceMediaId: orderData?.deliveryInfo?.invoiceMediaId,
      invoiceNo: orderData?.deliveryInfo?.invoiceNo,
      invoiceDate: orderData?.deliveryInfo?.invoiceDate,
      invoiceAmount: orderData?.deliveryInfo?.invoiceAmount,
      outstanding: orderData?.deliveryInfo?.balanceAmount,
      invoiceStatus: orderData?.deliveryInfo?.invoiceStatus,
      paymentLink: orderData?.deliveryInfo?.paymentLink,
    });

    setChallanInfo({
      title: "Garaaz",
      challanMediaId: orderData?.challanInfo?.challanMediaId,
      challanNo: orderData?.challanInfo?.challanNo,
      challanDate: orderData?.challanInfo?.challanDate,
      challanAmount: orderData?.challanInfo?.challanAmount,
    });
    setSupplierInvoiceInfo(
      orderData.allocatedTo.map((item: any) => ({
        ...item.invoiceInfo,
        supplierId: item.supplierId,
      })),
    );
    setSupplierChallanInfo(
      orderData.allocatedTo.map((item: any) => ({
        ...item.challanInfo,
        supplierId: item.supplierId,
      })),
    );
    setAssignedSupplier(orderData?.allocatedTo);

    const pcStartTime = orderData?.metaInfo?.partConversionStartTime;
    setIsPartConversionActive(!!pcStartTime);

    setAckClockValue0(
      Math.floor(new Date(orderData.orderDate).getTime() / 1000),
    );
    setAckClockValue100(
      Math.floor(new Date(orderData.orderDate).getTime() / 1000) +
        mobileConfigs?.threshold_ack_order_mins * 60,
    );
    setAckTimeMissed(false);
  }, [orderData]);

  useEffect(() => {
    const uniqueBrands: any = new Set(
      orderItems?.map((item: any) => item.brandId),
    );
    const uniqueBrandsArray = Array.from(uniqueBrands);
    if (uniqueBrandsArray.some((item) => !item)) {
      setFilteredSuppliers(allSuppliers);
    } else {
      const filteredSupplierTemp = allSuppliers?.filter((supplier: any) => {
        for (let i = 0; i < uniqueBrandsArray.length; i++) {
          let index = supplier.brands.indexOf(uniqueBrandsArray[i]);
          if (index === -1) {
            return false;
          }
        }
        return true;
      });
      setFilteredSuppliers(filteredSupplierTemp);
    }
  }, [orderItems, orderData, allSuppliers]);

  const saveOrderRemarks = async (
    remarks: string,
    garaazOrderRemarks?: string,
    supplierCancellationRemarksValue?: string,
    customerHoldRemarksValue?: string,
    promiseTimeBreachRemarksValue?: string,
  ) => {
    try {
      if (remarks) {
        let newOrderRemarks = [
          ...savedOrderRemarks,
          {
            userName: `${userDetails.firstName} ${userDetails.lastName}`,
            remarks: remarks,
          },
        ];
        setSavedOrderRemarks(orderData._id, newOrderRemarks);
        await services.setOrderRemarks(orderData._id, {
          userName: `${userDetails.firstName} ${userDetails.lastName}`,
          remarks,
        });
      }
      if (garaazOrderRemarks !== orderData?.garaazRemarks) {
        try {
          setGaraazRemarks(garaazOrderRemarks || "");
          const response = await services.updateOrder(orderData._id, {
            garaazRemarks: garaazOrderRemarks,
          });
        } catch (error) {
          toast({
            description: "Some error occured in Updating garaaz remarks",
            status: "error",
          });
        }
      }
      if (
        supplierCancellationRemarksValue !==
        orderData?.supplierCancellationReasons
      ) {
        try {
          setSupplierCancellationReasons(
            supplierCancellationRemarksValue || "",
          );
          const response = await services.updateOrder(orderData._id, {
            supplierCancellationReasons: supplierCancellationRemarksValue,
          });
        } catch (error) {
          toast({
            description:
              "Some error occured in Updating supplier cancellation reasons",
            status: "error",
          });
        }
      }
      if (customerHoldRemarksValue !== orderData?.customerHoldReasons) {
        try {
          setCustomerHoldReasons(customerHoldRemarksValue || "");
          const response = await services.updateOrder(orderData._id, {
            customerHoldReasons: customerHoldRemarksValue,
          });
        } catch (error) {
          toast({
            description: "Some error occured in Updating customer hold reasons",
            status: "error",
          });
        }
      }
      if (
        promiseTimeBreachRemarksValue !== orderData?.promiseTimeBreachReasons
      ) {
        try {
          setPromiseTimeBreachReasons(promiseTimeBreachRemarksValue || "");
          const response = await services.updateOrder(orderData._id, {
            promiseTimeBreachReasons: promiseTimeBreachRemarksValue,
          });
        } catch (error) {
          toast({
            description:
              "Some error occured in Updating promise time breach reasons",
            status: "error",
          });
        }
      }
    } catch (error) {}
  };

  const handleorderETAModalSubmit = async (
    etaGivenTime: string,
    eta: string,
    reason: string,
  ) => {
    try {
      const newEtaChangeReason = [...orderEta, { etaGivenTime, eta, reason }];
      setOrderEtasWithOrderId(orderData._id, newEtaChangeReason);
      await services.setOrderETA(orderData._id, {
        etaGivenTime,
        eta,
        reason,
      });
      setEtaMissed(false);
      refetchAllOrders();
    } catch (error) {}
  };

  const partConversionCurrentState = useMemo((): PartConversionState => {
    const partConversionStartTime =
      orderData?.metaInfo?.partConversionStartTime;
    const partConversionEndTime = orderData?.metaInfo?.partConversionEndTime;

    if (partConversionStartTime && partConversionEndTime) {
      return PartConversionState.COMPLETED;
    } else if (partConversionStartTime && !partConversionEndTime) {
      return PartConversionState.IN_PROGRESS;
    } else {
      return PartConversionState.NOT_STARTED;
    }
  }, [
    orderData?.metaInfo?.partConversionStartTime,
    orderData?.metaInfo?.partConversionEndTime,
  ]);

  const handlePartConversionToggle = async () => {
    try {
      const currentTime = new Date().toISOString();

      switch (partConversionCurrentState) {
        case PartConversionState.NOT_STARTED:
          await services.updateOrderMetaInfo(orderData._id, {
            partConversionStartTime: currentTime,
          });
          setOrderMetaInfoWithOrderId(orderData._id, {
            partConversionStartTime: currentTime,
          });
          toast({
            description: "Part conversion started successfully",
            status: "success",
          });
          break;

        case PartConversionState.IN_PROGRESS:
          await services.updateOrderMetaInfo(orderData._id, {
            partConversionEndTime: currentTime,
          });
          setOrderMetaInfoWithOrderId(orderData._id, {
            partConversionEndTime: currentTime,
          });
          toast({
            description: "Part conversion completed successfully",
            status: "success",
          });
          break;

        case PartConversionState.COMPLETED:
          return;
      }

      refetchCurrentOrder();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.errorMsg || "Failed to update part conversion";
      toast({
        description: errorMessage,
        status: "error",
      });
    }
  };

  const handleNoConversionNeeded = async () => {
    try {
      const currentTime = new Date().toISOString();
      await services.updateOrderMetaInfo(orderData._id, {
        partConversionStartTime: currentTime,
        partConversionEndTime: currentTime,
      });
      setOrderMetaInfoWithOrderId(orderData._id, {
        partConversionStartTime: currentTime,
        partConversionEndTime: currentTime,
      });
      toast({
        description: "Part conversion marked as not needed",
        status: "success",
      });
      refetchCurrentOrder();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.errorMsg ||
        "Failed to mark no part conversion needed";
      toast({
        description: errorMessage,
        status: "error",
      });
    }
  };

  const handleOrderHandlerChange = async (item: any) => {
    try {
      await services.updateOrder(orderData._id, {
        orderHandler: item.userId,
      });
      await updateOrderHandlerAllocationTime(
        orderData._id,
        setOrderMetaInfoWithOrderId,
      );
      try {
        const currentOrderHandler = orderData.orderHandler?.[0];
        const activeSupplier = orderData.allocatedTo?.find(
          (item: any) => item.isActive === true,
        );

        if (
          !activeSupplier?.supplierId ||
          !orderData?.orderNo ||
          !currentOrderHandler?._id
        ) {
          console.warn("Participant change skipped: missing prerequisites", {
            hasActiveSupplier: !!activeSupplier?.supplierId,
            hasOrderNo: !!orderData?.orderNo,
            hasCurrentHandler: !!currentOrderHandler?._id,
          });
        } else {
          const uniqueNameForSupplierConv = `order:${orderData.orderNo}|supplier:${activeSupplier.supplierId}`;
          const uniqueNameForCustomerConv = `order:${orderData.orderNo}|customer:${orderData.customerId}`;
          await changeParticipantInConversation({
            conversationName: uniqueNameForSupplierConv,
            oldHandlerUserId: currentOrderHandler._id,
            newHandlerUserId: item.userId,
          });

          await changeParticipantInConversation({
            conversationName: uniqueNameForCustomerConv,
            oldHandlerUserId: currentOrderHandler._id,
            newHandlerUserId: item.userId,
          });
        }
      } catch (error) {
        console.warn("Participant change failed:", error);
      }

      setSelectedOrderHandler(
        orderData._id,
        item.user,
        isChildOrder ? OrderRelationType.DESCENDANT : OrderRelationType.ROOT,
        orderData.rootOrderId,
      );
    } catch (error) {
      console.error("Failed to assign order handler:", error);
    }
  };

  const handleDeletionModalSubmit = async (inputtext: string) => {
    try {
      await services.deleteOrder(orderData._id, { deletionReason: inputtext });
      !!refetchAllOrders && refetchAllOrders();
      toast({
        description: OrdersTextLabels.ORDER_DELETED,
        status: "success",
      });
    } catch (error: any) {
      toast({
        description:
          error.response.data.errorMsg ?? OrdersTextLabels.SOMETHING_WENT_WRONG,
        status: "error",
      });
    }
  };

  const handleCancellationModalSubmit = async (input: string) => {
    try {
      setCancellationReason(input);
      const nextStateResponse = await services.cancelGaraazOrder(
        orderData._id,
        { cancellationReason: input },
      );

      setOrderStatus(OrderStatus.CANCELLED);
      !!refetchAllOrders && refetchAllOrders();
    } catch (error: any) {
      const errorFromResponse = error?.response?.data?.errorMsg;
      const title = !!errorFromResponse?.length
        ? errorFromResponse[0]?.title
        : OrdersTextLabels.ACCESS_DENIED_ORDER_STATUS_INVALID;
      garaazToast({
        title: title,
        status: "error",
        render: <OrderStatusChangeErrorBox errorMsg={errorFromResponse} />,
      });
    }
  };
  const handleAssignSupplierChange = async (
    item: any,
    supplierParts?: any[],
    transactionType?: string,
    creditNotePercentage?: number,
    discount?: number,
    selections?: NormalizedDeliverySelection[],
    cptGivenTime?: string,
    splitData?: EnrichedSupplierForDelivery[],
    estimateNo?: string,
  ) => {
    if (assignSupplierHook?.assignSupplier) {
      await assignSupplierHook.assignSupplier(
        item,
        item.supplierName,
        supplierParts,
        transactionType,
        discount,
        creditNotePercentage,
        selections,
        cptGivenTime,
        splitData,
        estimateNo,
      );
    }
  };

  const handleExecuteSupplierBucket = async (
    supplierBucket: any,
    transactionType?: string,
    creditNotePercentage?: number,
    discount?: number,
    selections?: NormalizedDeliverySelection[],
    cptGivenTime?: string,
    splitData?: EnrichedSupplierForDelivery[],
    estimateNo?: string,
  ) => {
    if (executeSupplierBucketHook?.executeSupplierBucket) {
      await executeSupplierBucketHook.executeSupplierBucket(
        supplierBucket,
        transactionType,
        creditNotePercentage,
        discount,
        selections,
        cptGivenTime,
        splitData,
        estimateNo,
      );
    }
  };

  const handleChangeOrderStatusToCBO = async (
    etaGivenTime: string,
    eta: string,
    reason: string,
    TobeAllocateSupplierId?: string,
    modalCloseFunction?: () => void,
  ) => {
    try {
      const response = await services.garaazOrderCBO(orderData._id, {
        supplierId: TobeAllocateSupplierId,
      });
      setOrderStatus(OrderStatus.CBO);
      setAssignedSupplier(response.allocatedTo);
      await handleorderETAModalSubmit(etaGivenTime, eta, reason);
      !!refetchAllOrders && refetchAllOrders();
    } catch (error: any) {
      const errorFromResponse = error?.response?.data?.errorMsg;
      const title = errorFromResponse[0].title
        ? errorFromResponse[0].title
        : OrdersTextLabels.CBO_STATE_INVALID;
      garaazToast({
        title: title,
        status: "error",
        render: <OrderStatusChangeErrorBox errorMsg={errorFromResponse} />,
      });
    } finally {
      if (modalCloseFunction) modalCloseFunction();
    }
  };

  const checkSamePartNumberOrders = async (
    customerId: string,
    startDate: string,
    endDate: string,
  ) => {
    const response = await services.getAllGaraazOrders(
      `&customerId=${customerId}&excludeOrderStatus=${OrderStatus.DELIVERED}&excludeOrderStatus=${OrderStatus.CANCELLED}&orderType=REGULAR&limit=500`,
    );

    const partIds = new Set(orderItems.map((item: any) => item.partId));
    const ordersWithSamePartNumbers: any[] = [];

    response?.families?.forEach((responseOrder: any) => {
      if (responseOrder.orderNo === orderData.orderNo) {
        return;
      }
      const responseOrderItems = responseOrder.orderItems || [];
      if (
        responseOrderItems.some((responseOrderItem: any) =>
          partIds.has(responseOrderItem.partId),
        )
      ) {
        ordersWithSamePartNumbers.push({
          orderNo: responseOrder.orderNo,
          orderHandlerName: `${responseOrder.orderHandler[0].firstName} ${responseOrder.orderHandler[0].lastName}`,
        });
      }
    });

    return ordersWithSamePartNumbers;
  };

  const handleChangeOrderStatus = async (
    status: OrderStatus | OrderActions,
    modalCloseFunction?: () => void,
  ) => {
    try {
      if (status === OrderStatus.ACK) {
        await updateAckTime(orderData._id, setOrderMetaInfoWithOrderId);
      }

      const currentUTCTimestamp = getCurrentUTCTimestamp();
      const transitionRes = await services.checkNextStateOfGaraazOrders(
        orderData._id,
        status,
      );
      const nextStateName = transitionRes?.nextStateObject?.stateName ?? status;
      setOrderStatus(nextStateName);

      if (
        status === OrderStatus.CUSTOMER_HOLD &&
        !orderData?.metaInfo?.[META_INFO_KEYS.CUSTOMER_HOLD_START_TIME]
      ) {
        await services.updateOrderMetaInfo(orderData._id, {
          [META_INFO_KEYS.CUSTOMER_HOLD_START_TIME]: currentUTCTimestamp,
        });
        setOrderMetaInfoWithOrderId(orderData._id, {
          [META_INFO_KEYS.CUSTOMER_HOLD_START_TIME]: currentUTCTimestamp,
        });
      } else if (status === OrderActions.CUSTOMER_UNHOLD) {
        await services.updateOrderMetaInfo(orderData._id, {
          [META_INFO_KEYS.CUSTOMER_HOLD_END_TIME]: currentUTCTimestamp,
        });
        setOrderMetaInfoWithOrderId(orderData._id, {
          [META_INFO_KEYS.CUSTOMER_HOLD_END_TIME]: currentUTCTimestamp,
        });
      } else if (nextStateName === OrderStatus.READY_TO_DISPATCH) {
        await services.updateOrderMetaInfo(orderData._id, {
          [META_INFO_KEYS.READY_TO_DISPATCH_TIME]: currentUTCTimestamp,
        });

        setOrderMetaInfoWithOrderId(orderData._id, {
          [META_INFO_KEYS.READY_TO_DISPATCH_TIME]: currentUTCTimestamp,
        });
        fire();
      }
      !!refetchAllOrders && refetchAllOrders();
    } catch (error: any) {
      const errorFromResponse = error?.response?.data?.errorMsg;
      const title = !!errorFromResponse.length
        ? errorFromResponse[0]?.title
        : OrdersTextLabels.ACCESS_DENIED_ORDER_STATUS_INVALID;
      garaazToast({
        title: title,
        status: "error",
        render: <OrderStatusChangeErrorBox errorMsg={errorFromResponse} />,
      });
    } finally {
      if (modalCloseFunction) modalCloseFunction();
    }
  };

  const handleUpdateInvoiceModalSubmit = async (
    pdfFile: File | null = null,
    invoiceInfo: invoiceInfoType,
    challanInfo: any,
    fileType: string,
  ) => {
    try {
      let updatedParts = {};
      if (fileType === "Invoice") {
        if (
          pdfFile !== null &&
          invoiceInfo.invoiceNo &&
          invoiceInfo.invoiceAmount
        ) {
          const formData = new FormData();
          formData.append("media", pdfFile);
          const mediaResult = await services.addMedia(formData);

          updatedParts = {
            invoiceInfo: {
              ...invoiceInfo,
              automaticallyCreatedInvoice: false,
              invoiceMediaId: mediaResult[0]._id,
              invoiceDate: dateFormatInvoiceApi(invoiceInfo.invoiceDate),
            },
          };
        } else {
          updatedParts = {
            invoiceInfo: {
              ...invoiceInfo,
              automaticallyCreatedInvoice: false,
              invoiceDate: dateFormatInvoiceApi(invoiceInfo.invoiceDate),
              invoiceMediaId:
                invoiceInfo.invoiceNo &&
                invoiceInfo.invoiceAmount &&
                invoiceInfo.invoiceDate
                  ? orderData?.invoiceInfo?.invoiceMediaId
                  : undefined,
            },
          };
        }

        const updatedOrderResponse = await services.updateOrder(
          orderData._id,
          updatedParts,
        );

        setInvoiceInfo({
          title: "Garaaz",
          invoiceType: "ORDER" as const,
          invoiceMediaId: updatedOrderResponse.invoiceInfo.invoiceMediaId,
          mrpInvoiceMediaId: updatedOrderResponse.invoiceInfo.mrpInvoiceMediaId,
          invoiceNo: updatedOrderResponse.invoiceInfo.invoiceNo,
          invoiceAmount: updatedOrderResponse.invoiceInfo.invoiceAmount,
          outstanding: updatedOrderResponse.invoiceInfo?.balanceAmount,
          invoiceDate: updatedOrderResponse.invoiceInfo.invoiceDate,
          invoiceStatus: updatedOrderResponse.invoiceInfo.invoiceStatus,
          paymentLink: updatedOrderResponse.invoiceInfo.paymentLink,
        });

        toast({
          description: OrdersTextLabels.INVOICE_UPLOADED_SUCCESSFULLY,
          status: "success",
        });
      } else {
        if (
          pdfFile !== null &&
          challanInfo.challanNo &&
          challanInfo.challanAmount
        ) {
          const formData = new FormData();
          formData.append("media", pdfFile);
          const mediaResult = await services.addMedia(formData);

          updatedParts = {
            challanInfo: {
              ...challanInfo,
              challanMediaId: mediaResult[0]._id,
              challanDate: dateFormatInvoiceApi(challanInfo.challanDate),
            },
          };
        } else {
          updatedParts = {
            challanInfo: {
              ...challanInfo,
              challanDate: dateFormatInvoiceApi(challanInfo.challanDate),
              challanMediaId:
                challanInfo.challanNo &&
                challanInfo.challanAmount &&
                challanInfo.challanDate
                  ? orderData?.challanInfo?.challanMediaId
                  : undefined,
            },
          };
        }

        const updatedOrderResponse = await services.updateOrder(
          orderData._id,
          updatedParts,
        );

        setChallanInfo({
          title: "Garaaz",
          challanMediaId: updatedOrderResponse.challanInfo.challanMediaId,
          challanNo: updatedOrderResponse.challanInfo.challanNo,
          challanAmount: updatedOrderResponse.challanInfo.challanAmount,
          challanDate: updatedOrderResponse.challanInfo.challanDate,
        });

        toast({
          description: OrdersTextLabels.CHALLAN_UPLOADED_SUCCESSFULLY,
          status: "success",
        });
      }
    } catch (error) {
      toast({
        description: OrdersTextLabels.SOMETHING_WENT_WRONG,
        status: "error",
      });
    }
  };

  const handleRegenerateInvoice = async () => {
    try {
      await services.regenerateOrderInvoice(orderData._id);
      toast({
        description:
          "Invoice regeneration has been started. It may take a few moments for the new invoice to appear.",
        status: "success",
      });
      refetchAllOrders();
    } catch (error: any) {
      const message =
        error?.response?.data?.errorMsg ??
        "Could not start invoice regeneration.";
      toast({
        description: Array.isArray(message) ? message[0]?.title : message,
        status: "error",
      });
      throw error;
    }
  };

  const isSupplierInvoicePresent = useMemo(
    () => hasSupplierInvoice(activesupplierOrderStatus?.invoiceInfo),
    [activesupplierOrderStatus?.invoiceInfo],
  );

  const uniqueNumbersInQuickEtas = useMemo(() => {
    return mobileConfigs?.quick_etas_mins
      ?.split(",")
      ?.filter(
        (value: any, index: number, array: any) =>
          array.indexOf(value) === index && !isNaN(parseInt(value)),
      );
  }, [mobileConfigs]);
  const quickEtasCBOOrderDays = useMemo(() => {
    return mobileConfigs?.quick_etas_cbo_order_days
      ?.split(",")
      ?.filter(
        (value: any, index: number, array: any) =>
          array.indexOf(value) === index && !isNaN(parseInt(value)),
      );
  }, [mobileConfigs]);
  const mobileNumbersAllowedToProceedR2D = useMemo(() => {
    return (
      mobileConfigs?.mobile_numbers_allowed_to_proceed_ready_for_dispatch_in_orca?.split(
        ",",
      ) || []
    );
  }, [mobileConfigs]);

  async function onAckTimeComplete() {
    const response = await services.throwACKMissedEvent(orderData._id);
  }

  async function loadReturnOrders() {
    const response = await services.getReturnedOrderItems(orderData._id);
    setReturnOrders(response);
  }
  async function loadCBOOrders() {
    const response = await services.getCBOOrders(orderData._id);
    setCBOOrders(response);
  }

  const isPartConversionCompleted = () => {
    return partConversionCurrentState === PartConversionState.COMPLETED;
  };

  async function handleReadyToDispatchButtonClick() {
    setIsSamePartNumberOrdersLoading(true);
    const ordersWithSamePartNumbers = await checkSamePartNumberOrders(
      orderData.customerId,
      orderData.orderDate,
      orderData.orderDate,
    );
    setIsSamePartNumberOrdersLoading(false);
    setSamePartNumberOrders(ordersWithSamePartNumbers);
    if (ordersWithSamePartNumbers.length === 0) {
      onOpenREADY_TO_DISPATCHOrderDialogue();
    } else {
      onOpenSamePartNumberFoundInOtherOrderDialogue();
    }
  }

  function isLossOrder() {
    return (
      Number(activesupplierOrderStatus?.invoiceInfo?.invoiceAmount) >
      Number(invoiceInfo?.invoiceAmount)
    );
  }

  const isInvoiceNotPaidOrReceived = useMemo(() => {
    return (
      orderData.invoiceInfo?.invoiceNo &&
      orderData.invoiceInfo?.invoiceStatus !== "PAID" &&
      orderData.invoiceInfo?.invoiceStatus !== "RECEIVED"
    );
  }, [orderData]);

  const isDeliveryInvoiceNotPaidOrReceived = useMemo(() => {
    return (
      orderData.deliveryInfo?.invoiceNo &&
      orderData.deliveryInfo?.invoiceStatus !== "PAID" &&
      orderData.deliveryInfo?.invoiceStatus !== "RECEIVED"
    );
  }, [orderData]);

  const [isUnblockRequestLoading, setIsUnblockRequestLoading] = useState(false);

  const handleRequestUnblock = async () => {
    setIsUnblockRequestLoading(true);
    try {
      await handleChangeOrderStatus(OrderActions.UNBLOCK);
    } finally {
      setIsUnblockRequestLoading(false);
    }
  };

  return (
    <HStack
      flex={1}
      height={"12%"}
      borderRadius={"0px 0px 8px 8px"}
      borderTop={"1px solid lightgrey"}
      borderBottom={"1px solid lightgrey"}
      style={{
        margin: 0,
      }}
      display={"flex"}
      padding={`${startOrcaStates.includes(orderStatus) ? 0 : "0.8rem"}`}
      py={`${startOrcaStates.includes(orderStatus) ? 0 : "1.5rem"}`}
      alignItems={"center"}
      bgColor={"white"}
    >
      {startOrcaStates.includes(orderStatus) ? (
        <Button
          borderTopLeftRadius={0}
          borderTopRightRadius={0}
          height={"100%"}
          width={"100%"}
          bg={"green.500"}
          _hover={{ bg: "green.600" }}
          color={"white"}
          onClick={() => handleChangeOrderStatus(OrderStatus.ACK)}
        >
          <Text fontSize={"lg"}>ACK</Text>
          {!orderEta.length && (
            <Box ml="5" display={"flex"}>
              {!ackTimeMissed && (
                <GaraazCountDownClockV2
                  componentSize="small"
                  value0={ackClockValue0}
                  value100={ackClockValue100}
                  onCompleteTime={onAckTimeComplete}
                  isCompleted={ackTimeMissed}
                  setIsCompleted={setAckTimeMissed}
                ></GaraazCountDownClockV2>
              )}

              {ackTimeMissed && (
                <HStack spacing={1}>
                  <FiAlertTriangle color="red" style={{ marginLeft: "2px" }} />
                  <Text>ACK Missed</Text>
                </HStack>
              )}
            </Box>
          )}
        </Button>
      ) : (
        <>
          <HStack spacing={3} w="45%">
            <Box>
              <Tooltip label="Flip View">
                <IconButton
                  icon={<GiCardExchange />}
                  backgroundColor={"#BBE6E3"}
                  color={"black"}
                  aria-label={""}
                  onClick={handlePartConversionChangeScreen}
                />
              </Tooltip>
            </Box>
            {(() => {
              if (partConversionCurrentState === PartConversionState.COMPLETED)
                return null;

              const getButtonConfig = () => {
                switch (partConversionCurrentState) {
                  case PartConversionState.NOT_STARTED:
                    return {
                      icon: <FaPlay />,
                      backgroundColor: "#68D391",
                      hoverColor: "#48BB78",
                      label: "Start Part Conversion",
                      ariaLabel: "Start",
                      showSkipButton: true,
                    };
                  case PartConversionState.IN_PROGRESS:
                    return {
                      icon: <FaStop />,
                      backgroundColor: "#F6AD55",
                      hoverColor: "#ED8936",
                      label: "Complete Part Conversion",
                      ariaLabel: "Complete",
                      showSkipButton: false,
                    };
                  default:
                    return null;
                }
              };

              const buttonConfig = getButtonConfig();
              if (!buttonConfig) return null;

              return (
                <>
                  <Box>
                    <Tooltip
                      label={buttonConfig.label}
                      placement="top"
                      hasArrow
                    >
                      <IconButton
                        icon={buttonConfig.icon}
                        backgroundColor={buttonConfig.backgroundColor}
                        color="white"
                        aria-label={buttonConfig.ariaLabel}
                        onClick={handlePartConversionToggle}
                        _hover={{
                          backgroundColor: buttonConfig.hoverColor,
                          transform: "translateY(-1px)",
                        }}
                        _active={{ transform: "translateY(0px)" }}
                        transition="all 0.2s ease-in-out"
                      />
                    </Tooltip>
                  </Box>
                  {buttonConfig.showSkipButton && (
                    <Box>
                      <Tooltip
                        label="No Part Conversion Needed"
                        placement="top"
                        hasArrow
                      >
                        <IconButton
                          icon={<FaTimes />}
                          backgroundColor="#E53E3E"
                          color="white"
                          aria-label="No Part Conversion"
                          onClick={handleNoConversionNeeded}
                          _hover={{
                            backgroundColor: "#C53030",
                            transform: "translateY(-1px)",
                          }}
                          _active={{ transform: "translateY(0px)" }}
                          transition="all 0.2s ease-in-out"
                        />
                      </Tooltip>
                    </Box>
                  )}
                </>
              );
            })()}
            <Box>
              <GaraazChoser
                ButtonIcon={<PersonOutlineOutlined />}
                ButtonToolTipLabel={`Assign ${orderLabel} Handler`}
                MenuItemOnChange={handleOrderHandlerChange}
                displayKey="name"
                options={orderHandlerOptions}
                showIcon={true}
                MenuButtonProps={{
                  isDisabled:
                    orderStatus === OrderStatus.READY_TO_DISPATCH ||
                    orderStatus === OrderStatus.DELIVERED,
                }}
              />
            </Box>
            {/* <Box position={"relative"}>
              <GaraazChoser
                ButtonIcon={<GrTransaction></GrTransaction>}
                ButtonToolTipLabel="Transaction Type"
                MenuItemOnChange={(option) => {
                  if (option.type === "Trading") {
                    setIsTradingModalOpen(true);
                  } else {
                    handleTransactionTypeChange(option);
                  }
                }}
                displayKey="type"
                options={transactionTypeOption}
                MenuButtonProps={{
                  isDisabled:
                    isCustomerOrderFreezed ||
                    activesupplierOrderStatus?.orderStatus ===
                      OrderStatus.READY,
                }}
              />
              <Box position={"absolute"} bottom={260}>
                {isTradingModalOpen && (
                  <Popover
                    isOpen={isTradingModalOpen}
                    onClose={() => setIsTradingModalOpen(false)}
                  >
                    <PopoverContent maxWidth={"17em"} color="#1a202c">
                      <PopoverHeader>
                        <Text fontWeight={"700"} fontSize={"15px"}>
                          Customer Discount & Credit
                        </Text>
                      </PopoverHeader>
                      <PopoverBody>
                        <VStack alignItems={"flex-start"}>
                          <label
                            style={{
                              marginRight: "auto",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Discount
                          </label>
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            gap={1}
                            width={"100%"}
                          >
                            <NumberInput
                              width={"100%"}
                              value={discount}
                              onChange={(e) => {
                                const value = Number(e);
                                if (value >= 0 && value <= 100) {
                                  setDiscount(e);
                                } else {
                                  toast({
                                    description:
                                      "Discount must be between 0 and 100",
                                    status: "warning",
                                  });
                                }
                              }}
                              size={"sm"}
                            >
                              <NumberInputField placeholder="Enter Customer Discount" />
                            </NumberInput>
                            {"%"}
                          </Box>

                          <label
                            style={{
                              marginRight: "auto",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            Credit
                          </label>
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            gap={1}
                            width={"100%"}
                          >
                            <NumberInput
                              width={"100%"}
                              value={creditNotePercentage}
                              onChange={(e) => {
                                const value = Number(e);
                                if (value >= 0 && value <= 100) {
                                  setCreditNotePercentage(e);
                                } else {
                                  toast({
                                    description:
                                      "Customer credit must be between 0 and 100",
                                    status: "warning",
                                });
                                }
                              }}
                              size={"sm"}
                            >
                              <NumberInputField placeholder="Enter Customer credit" />
                            </NumberInput>
                            {"%"}
                          </Box>

                          <Button
                            colorScheme="blue"
                            size={"xs"}
                            onClick={() => {
                              handleConfirmDiscountSubmit();
                            }}
                            marginLeft={"auto"}
                            marginTop={1}
                          >
                            Confirm
                          </Button>
                        </VStack>
                      </PopoverBody>
                    </PopoverContent>
                  </Popover>
                )}
              </Box>
            </Box> */}
            <Box>
              <Tooltip label="Assign Supplier">
                <IconButton
                  icon={<GiCrownedSkull />}
                  backgroundColor={"#BBE6E3"}
                  color={"black"}
                  aria-label={""}
                  onClick={() => {
                    if (
                      orderData?.isOrderItemsExtractedByOpenAI ||
                      orderData?.isVehicleInfoExtractedByOpenAI
                    ) {
                      onOrderDetailsExtractedByPhantomModalOpen();
                    } else {
                      onSupplierInventorySearchModalOpen();
                    }
                  }}
                  isDisabled={!isPartConversionCompleted()}
                />
              </Tooltip>
              <SupplierInventorySearch
                isOpen={isSupplierInventorySearchModalOpen}
                onClose={() => {
                  onSupplierInventorySearchModalClose();
                }}
                onSelectionClose={() => {
                  onSupplierInventorySearchModalClose();
                }}
                preFacetedPartNumbers={(orderItems || [])
                  .filter((item: any) => item.remainingDecisionQuantity > 0)
                  .map((item: any) => ({
                    partNumber: item.partNumber,
                    rootPartNumber: item.rootPartNumber,
                    quantity: item.remainingDecisionQuantity,
                    partName: item.partName,
                    partId: item.partId,
                    mrp: item.mrp,
                  }))}
                customerGeoPoint={orderData?.shipmentAddress?.location}
                handleSelectListItem={handleAssignSupplierChange}
                associations={orderData?.customer?.supplierAssociations}
                orderId={orderData._id}
                orderNumber={orderData?.orderNo}
                setTransactionType={setTransactionType}
                orderData={orderData}
                handleExecuteSupplierBucket={handleExecuteSupplierBucket}
                isSupplierBucketExecuting={
                  executeSupplierBucketHook.isExecuting
                }
                allSuppliers={allSuppliers}
                filteredSuppliers={filteredSuppliers}
                refetchAllOrders={refetchAllOrders}
              ></SupplierInventorySearch>

              <GaraazInfoDialogue
                isOpen={isOrderDetailsExtractedByPhantomModalOpen}
                onOpen={onOrderDetailsExtractedByPhantomModalOpen}
                onClose={() => {
                  onOrderDetailsExtractedByPhantomModalClose();
                  onSupplierInventorySearchModalOpen();
                }}
                leftBtnText={"Already Reviewed"}
                submitBtnText={"Review"}
                onSubmitBtn={onOrderDetailsExtractedByPhantomModalClose}
                alertBodyText={
                  "This order might contain some order items or vehicle related information extracted by Phantom. Please review before proceeding."
                }
                alertGenericHeaderText={
                  <Text fontSize={"xl"} display={"flex"} alignItems={"center"}>
                    Phantom Alert !
                    <Image
                      width={30}
                      src="https://garaaz-store.s3.ap-south-1.amazonaws.com/7a6e6ff21a3b4239bf82d94d38a7e5ef.png"
                    ></Image>
                  </Text>
                }
              ></GaraazInfoDialogue>
            </Box>
            <Box>
              <Tooltip label="ETA">
                <IconButton
                  icon={<FaHourglassHalf />}
                  backgroundColor={"#BBE6E3"}
                  color={"black"}
                  aria-label={""}
                  onClick={openETAPickerModal}
                />
              </Tooltip>
              <GaraazDatePickerModalETA
                modelHeader="Please provide ETA for Customer"
                isOpen={etaPickerModalOpen}
                orderETAs={orderEta}
                handleSubmit={handleorderETAModalSubmit}
                onClose={closeETAPickerModal}
                modifiedOrderETAs={uniqueNumbersInQuickEtas}
              />
            </Box>
            <Box>
              <Tooltip label="Upload Invoice">
                <IconButton
                  isDisabled={
                    activesupplierOrderStatus?.orderStatus !==
                      OrderStatus.READY || isCustomerOrderFreezed
                  }
                  icon={<GrUpload />}
                  backgroundColor={"#BBE6E3"}
                  color={"black"}
                  aria-label={""}
                  onClick={openUpdateInvoiceModal}
                />
              </Tooltip>
              <UploadInvoiceModal
                isOpen={updateInvoiceModalOpen}
                orderInvoiceInfo={invoiceInfo}
                orderChallanInfo={challanInfo}
                handleSubmit={handleUpdateInvoiceModalSubmit}
                onClose={closeUpdateInvoiceModal}
                isSupplierInvoicePresent={isSupplierInvoicePresent}
              />
            </Box>
            <Box>
              <Tooltip label={`Add ${orderLabel} Remarks`}>
                <IconButton
                  icon={<RiMenuAddFill />}
                  backgroundColor={"#BBE6E3"}
                  color={"black"}
                  aria-label={""}
                  onClick={openOrdersRemarksModel}
                />
              </Tooltip>
              <TextInputModal
                modalHeader={`${orderLabel} Remarks`}
                inputPlaceHolder={`Add ${orderLabel} Remarks`}
                isOpen={orderRemarksModelOpen}
                onSave={saveOrderRemarks}
                onClose={closeOrdersRemarksModel}
                displaySecondaryInput={true}
                secondaryInput={garaazRemarks || ""}
                modalSecondaryHeader="Garaaz Remarks"
                secondaryInputPlaceHolder="Add Garaaz Remarks"
                displayThirdInput={true}
                modalThirdHeader="Supplier Cancellation Reasons"
                thirdInputPlaceHolder="Add Supplier Cancellation Reason"
                thirdInput={supplierCancellationReasons || ""}
                displayFourthInput={true}
                modalFourthHeader="Customer Hold Reasons"
                fourthInputPlaceHolder="Add Customer Hold Reason"
                fourthInput={customerHoldReasons || ""}
                displayFifthInput={true}
                modalFifthHeader="Promise Time Breach Reasons"
                fifthInputPlaceHolder="Add Promise Time Breach Reason"
                fifthInput={promiseTimeBreachReasons || ""}
              />
            </Box>
            {orderStatus === OrderStatus.BLOCKED && (
              <Box>
                <Tooltip label="Request unblock">
                  <IconButton
                    icon={
                      isUnblockRequestLoading ? (
                        <Spinner size="sm" />
                      ) : (
                        <LockOpenOutlinedIcon />
                      )
                    }
                    backgroundColor={"#BBE6E3"}
                    color={"black"}
                    aria-label="Request unblock"
                    onClick={handleRequestUnblock}
                    isDisabled={isUnblockRequestLoading}
                  />
                </Tooltip>
              </Box>
            )}
            <Popover placement="top-start">
              <PopoverTrigger>
                <Box>
                  <Tooltip label="Meta Actions">
                    <IconButton
                      icon={<CheckCircleOutlineIcon />}
                      backgroundColor={"#BBE6E3"}
                      color={"black"}
                      aria-label={""}
                    />
                  </Tooltip>
                </Box>
              </PopoverTrigger>

              <PopoverContent>
                <PopoverArrow />

                <PopoverBody
                  display={"flex"}
                  width={"100%"}
                  justifyContent={"space-between"}
                >
                  {" "}
                  <>
                    <Box>
                      <Tooltip label="Ready to Dispatch Order">
                        <IconButton
                          icon={
                            isSamePartNumberOrdersLoading ? (
                              <Spinner></Spinner>
                            ) : (
                              <CheckIcon />
                            )
                          }
                          backgroundColor={"#BBE6E3"}
                          color={"black"}
                          aria-label={""}
                          onClick={() => {
                            if (
                              isLossOrder() &&
                              orderData.transactionType === "Trading"
                            ) {
                              onOpenLossOrderDialogue();
                            } else {
                              handleReadyToDispatchButtonClick();
                            }
                          }}
                          isDisabled={isCustomerOrderFreezed}
                        />
                      </Tooltip>
                      <GaraazErrorDialogue
                        alertBodyText={
                          "The Supplier Invoice Amount is greater than the Customer Invoice Amount, leading to a potential loss on this order. Please review and revise the invoices to ensure profitability before proceeding with order processing."
                        }
                        alertGenericHeaderText="Pricing Alert - Loss detected"
                        isOpen={isOpenLossOrderDialogue}
                        leftBtnText={
                          isSamePartNumberOrdersLoading ? (
                            <Spinner></Spinner>
                          ) : (
                            "Proceed Anyway"
                          )
                        }
                        onClose={async () => {
                          await handleReadyToDispatchButtonClick();
                          onCloseLossOrderDialogue();
                        }}
                        onOpen={onOpenLossOrderDialogue}
                        onSubmitBtn={onCloseLossOrderDialogue}
                        submitBtnText="Review"
                        isLeftButtonDisabled={
                          !mobileNumbersAllowedToProceedR2D?.includes(
                            userDetails.mobileNumber,
                          )
                        }
                      ></GaraazErrorDialogue>
                      <GaraazAlertDialogue
                        alertBodyText="Are you sure? You can't undo this action afterwards."
                        alertDialogueHeaderText="Mark as Ready to Dispatch"
                        onSubmitBtn={() =>
                          handleChangeOrderStatus(
                            OrderStatus.READY_TO_DISPATCH,
                            onCloseREADY_TO_DISPATCHOrderDialogue,
                          )
                        }
                        isOpen={isOpenREADY_TO_DISPATCHOrderDialogue}
                        onClose={onCloseREADY_TO_DISPATCHOrderDialogue}
                        onOpen={onOpenREADY_TO_DISPATCHOrderDialogue}
                        submitBtnText="Confirm"
                      />
                      <GaraazErrorDialogue
                        alertBodyText={
                          <Box display={"flex"} flexDirection={"column"}>
                            <Text>
                              We noticed similar part numbers in others orders
                              from {orderData.customer.name}. To ensure
                              accuracy, please review the following orders
                              before confirming.
                            </Text>
                            <UnorderedList mt={3} mb={3}>
                              {samePartNumberOrders.map((order) => {
                                return (
                                  <ListItem>
                                    {" "}
                                    <Box
                                      key={order.orderNo}
                                      display={"flex"}
                                      alignItems={"center"}
                                    >
                                      <Text>{order.orderNo}</Text>
                                      <GarrazCopyText
                                        popOverMessage={`${orderLabel} No Copied Successfully !`}
                                        text={order.orderNo}
                                      ></GarrazCopyText>
                                      <Text ml={1}>
                                        {" "}
                                        : {order.orderHandlerName}
                                      </Text>
                                    </Box>
                                  </ListItem>
                                );
                              })}
                            </UnorderedList>
                          </Box>
                        }
                        alertGenericHeaderText="Hold on! Similar Part Numbers Detected"
                        isOpen={isOpenSamePartNumberFoundInOtherOrderDialogue}
                        onClose={() => {
                          reviewSamePartOrdersLinkRef.current.click();
                          onCloseSamePartNumberFoundInOtherOrderDialogue();
                        }}
                        onOpen={onOpenSamePartNumberFoundInOtherOrderDialogue}
                        onSubmitBtn={() =>
                          handleChangeOrderStatus(
                            OrderStatus.READY_TO_DISPATCH,
                            onCloseSamePartNumberFoundInOtherOrderDialogue,
                          )
                        }
                        submitBtnText="Confirm"
                        leftBtnText="Review Orders"
                      ></GaraazErrorDialogue>
                      <Link
                        target="_blank"
                        as={NavLink}
                        to={`${
                          paths.samePartOrders
                        }?orderNo=${samePartNumberOrders
                          .map((order) => order.orderNo)
                          .join("&orderNo=")}`}
                        ref={reviewSamePartOrdersLinkRef}
                      ></Link>
                      <Portal>
                        <ReactCanvasConfetti
                          refConfetti={getInstance}
                          style={{
                            position: "fixed",
                            pointerEvents: "none",
                            width: "100vw",
                            height: "100vh",
                            top: 0,
                            left: 0,
                            zIndex: 10000,
                          }}
                        />
                      </Portal>
                    </Box>
                    <Box>
                      <Tooltip label="CBO Order">
                        <IconButton
                          icon={<LowPriorityIcon />}
                          backgroundColor={"#BBE6E3"}
                          color={"black"}
                          aria-label={""}
                          onClick={onOpenCBOOrderDialogue}
                          isDisabled={isCustomerOrderFreezed}
                        />
                      </Tooltip>
                      <GaraazDatePickerModalETA
                        modelHeader="Please provide ETA for CBO"
                        isOpen={isOpenCBOOrderDialogue}
                        onClose={onCloseCBOOrderDialogue}
                        orderETAs={orderEta}
                        okBtnText="Confirm"
                        handleSubmit={handleChangeOrderStatusToCBO}
                        modifiedOrderETAs={quickEtasCBOOrderDays}
                        allAlocatedSuppliers={assignedSupplier}
                        activeSupplierId={activesupplierOrderStatus?.supplierId}
                        isCBOETAPicker={true}
                      />
                    </Box>
                    <Box>
                      <Tooltip
                        label={`${
                          orderStatus === OrderStatus.CUSTOMER_HOLD
                            ? "Resume"
                            : "Customer Hold"
                        }`}
                      >
                        <IconButton
                          icon={
                            orderStatus === OrderStatus.CUSTOMER_HOLD ? (
                              <FaRegPlayCircle></FaRegPlayCircle>
                            ) : (
                              <FaRegPauseCircle />
                            )
                          }
                          backgroundColor={"#BBE6E3"}
                          color={"black"}
                          aria-label={""}
                          onClick={onOpenCUSTOMER_HOLDOrderDialogue}
                        />
                      </Tooltip>
                      <GaraazAlertDialogue
                        alertBodyText={
                          orderStatus === OrderStatus.CUSTOMER_HOLD
                            ? "This action will remove the 'Customer Hold' status and allow the order to proceed."
                            : "This action will pause the order processing until further notice from the customer."
                        }
                        alertDialogueHeaderText={`${
                          orderStatus === OrderStatus.CUSTOMER_HOLD
                            ? "Resume"
                            : "Customer Hold"
                        }`}
                        onSubmitBtn={async () => {
                          await handleChangeOrderStatus(
                            orderStatus === OrderStatus.CUSTOMER_HOLD
                              ? OrderActions.CUSTOMER_UNHOLD
                              : OrderStatus.CUSTOMER_HOLD,
                            onCloseCUSTOMER_HOLDOrderDialogue,
                          );
                        }}
                        isOpen={isOpenCUSTOMER_HOLDOrderDialogue}
                        onClose={onCloseCUSTOMER_HOLDOrderDialogue}
                        onOpen={onOpenCUSTOMER_HOLDOrderDialogue}
                        submitBtnText="Confirm"
                      />
                    </Box>
                    <Box>
                      <Tooltip label="Return Order">
                        <IconButton
                          icon={<GiReturnArrow />}
                          backgroundColor={"#BBE6E3"}
                          color={"black"}
                          aria-label={""}
                          onClick={onOpenReturnModal}
                          isDisabled={orderStatus !== OrderStatus.DELIVERED}
                        />
                      </Tooltip>
                      <OrderReturnModal
                        orderData={orderData}
                        orderId={orderData._id}
                        isOpen={isReturnOrderModalOpen}
                        onClose={onCloseReturnModal}
                        refetchAllOrders={refetchAllOrders}
                      ></OrderReturnModal>
                    </Box>

                    <Box>
                      <Tooltip label={`Cancel ${orderLabel}`}>
                        <IconButton
                          icon={<ClearOutlinedIcon />}
                          backgroundColor={"#BBE6E3"}
                          color={"black"}
                          aria-label={""}
                          onClick={openOrderCancellationReasonModal}
                          isDisabled={isEnquiryOrder}
                        />
                      </Tooltip>
                      <OrderCancellationModal
                        orderCacellationReasons={orderCancellationReason}
                        isOpen={orderCancellationReasonModalOpen}
                        handleSubmit={handleCancellationModalSubmit}
                        onClose={closeOrderCancellationReasonModal}
                      />
                    </Box>
                  </>
                  {isAllowedToChangeTransactionType && (
                    <Box>
                      <Tooltip label="Change Transaction Type">
                        <IconButton
                          icon={<SwapHoriz />}
                          backgroundColor={"#BBE6E3"}
                          color={"black"}
                          aria-label={"Change Transaction Type"}
                          onClick={() => setIsChangeTransactionTypeOpen(true)}
                        />
                      </Tooltip>
                      <TransactionTypeSelectComponent
                        isOpen={isChangeTransactionTypeOpen}
                        onClose={() => setIsChangeTransactionTypeOpen(false)}
                        onSuccess={(
                          transactionType,
                          updatedDiscount,
                          updatedCreditNotePercentage,
                        ) => {
                          setTransactionType(transactionType);
                          if (updatedDiscount !== undefined)
                            setDiscount(String(updatedDiscount));
                          if (updatedCreditNotePercentage !== undefined)
                            setCreditNotePercentage(
                              String(updatedCreditNotePercentage),
                            );
                          refetchAllOrders();
                        }}
                        orderId={orderData._id}
                        setTransactionType={setTransactionType}
                        orderData={orderData}
                        supplierId={activesupplierOrderStatus?.supplierId}
                        garaazSupplierIdFromConfig={
                          mobileConfigs?.garaaz_supplier_id ||
                          "64ae87c051c0be36170dc718"
                        }
                      />
                    </Box>
                  )}
                </PopoverBody>
              </PopoverContent>
            </Popover>

            <Popover placement="top-start">
              <PopoverTrigger>
                <Box>
                  <Tooltip label="Advanced Actions">
                    <IconButton
                      isDisabled={
                        !isInvoiceNotPaidOrReceived &&
                        !isDeliveryInvoiceNotPaidOrReceived
                          ? (role !== constants.SUPER_ADMIN &&
                              orderStatus === OrderStatus.READY_TO_DISPATCH) ||
                            orderStatus === OrderStatus.DELIVERED ||
                            isCustomerOrderFreezed
                          : false
                      }
                      icon={<BsThreeDots />}
                      backgroundColor={"#BBE6E3"}
                      color={"black"}
                      aria-label={""}
                    />
                  </Tooltip>
                </Box>
              </PopoverTrigger>

              <PopoverContent
                width={
                  isInvoiceNotPaidOrReceived &&
                  isDeliveryInvoiceNotPaidOrReceived
                    ? "16rem"
                    : isInvoiceNotPaidOrReceived ||
                        isDeliveryInvoiceNotPaidOrReceived
                      ? "13rem"
                      : "10rem"
                }
              >
                <PopoverArrow />

                <PopoverBody
                  display={"flex"}
                  width={"100%"}
                  justifyContent={"space-between"}
                >
                  <Box>
                    <Tooltip label="Merge Order">
                      <IconButton
                        icon={<CallMergeIcon></CallMergeIcon>}
                        backgroundColor={"#BBE6E3"}
                        color={"black"}
                        aria-label={""}
                        onClick={onOpenOrderMergeModal}
                        // isDisabled={orderStatus !== OrderStatus.ACK}
                        isDisabled={true}
                      />
                    </Tooltip>
                    <OrderMergeModal
                      isOpen={isOrderMergeModalOpen}
                      onClose={onCloseOrderMergeModal}
                      refetchAllOrders={refetchAllOrders}
                      orderData={orderData}
                    />
                  </Box>
                  {/* INFO: Forcefully disabling as no one uses this button to split order */}
                  <Box>
                    <Tooltip label="Split Order">
                      <IconButton
                        icon={<AltRoute></AltRoute>}
                        backgroundColor={"#BBE6E3"}
                        color={"black"}
                        aria-label={""}
                        onClick={onOpenOrderSplitModal}
                        // isDisabled={orderStatus !== OrderStatus.ACK}
                        isDisabled={true}
                      />
                    </Tooltip>
                    <OrderSplitModal
                      isOpen={isOrderSplitModalOpen}
                      onClose={onCloseOrderSplitModal}
                      orderId={orderData?._id}
                      orderData={orderData}
                      refetchAllOrders={refetchAllOrders}
                    />
                  </Box>

                  <Box>
                    <Tooltip label="Delete Order">
                      <IconButton
                        icon={<DeleteIcon />}
                        backgroundColor={"#BBE6E3"}
                        color={"black"}
                        aria-label={""}
                        onClick={openOrderDeletionReasonModal}
                        isDisabled={
                          !(
                            userDetails.userSubType === Roles.EXECUTIVE ||
                            userDetails.userSubType === Roles.HEAD_OF_OPERATIONS
                          )
                        }
                      />
                    </Tooltip>
                    <TextInputModal
                      modalHeader="Are you sure ?"
                      inputPlaceHolder="Add deletion reason"
                      isOpen={orderDeletionReasonModalOpen}
                      onSave={handleDeletionModalSubmit}
                      onClose={closeOrderDeletionReasonModal}
                      showActionText={true}
                      submitBtnText="Confirm"
                      cancelBtnText="Cancel"
                    />
                  </Box>
                  {isInvoiceNotPaidOrReceived && (
                    <Box>
                      <Tooltip label="Receive Invoice Payment">
                        <IconButton
                          icon={<FaRupeeSign />}
                          backgroundColor={"#BBE6E3"}
                          color={"black"}
                          aria-label={"Receive Invoice Payment"}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenCollectPaymentModal(
                              orderData?.orderNo,
                              orderData?.invoiceInfo,
                              orderData?.customer?.advancePayment || 0,
                            );
                          }}
                        />
                      </Tooltip>
                    </Box>
                  )}
                  {isDeliveryInvoiceNotPaidOrReceived && (
                    <Box>
                      <Tooltip label="Receive Delivery Payment">
                        <IconButton
                          icon={<FaRupeeSign color="rgb(37, 115, 250)" />}
                          backgroundColor={"#BBE6E3"}
                          color={"black"}
                          aria-label={"Receive Delivery Payment"}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenCollectPaymentModal(
                              orderData?.orderNo,
                              orderData?.deliveryInfo,
                              orderData?.customer?.advancePayment || 0,
                              InvoiceType.DELIVERY,
                            );
                          }}
                        />
                      </Tooltip>
                    </Box>
                  )}
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </HStack>
          <Box
            display={"flex"}
            flexWrap="wrap"
            gap={5}
            style={{ marginLeft: "auto", alignItems: "start" }}
            paddingTop={orderStatus === OrderStatus.NEW ? 5 : 2.5}
          >
            <GaraazInfoPopover
              triggerLabel="RETURNS"
              groups={[
                {
                  subgroups: [
                    {
                      title: "Return Orders",
                      items:
                        returnOrders.length > 0
                          ? returnOrders.map((order: any) => ({
                              key: "Order No",
                              value: order.orderNo,
                              copyable: true,
                              onClick: () => {
                                redirectToOrderPage(order?.orderNo);
                              },
                              itemStyle: {
                                cursor: "pointer",
                                marginLeft: "-1px",
                                marginBottom: "15px",
                              },
                            }))
                          : [
                              {
                                value: "No Return Order",
                                itemStyle: {
                                  marginLeft: "-1px",
                                },
                              },
                            ],
                      subgroupTitleStyle: {
                        marginLeft: "-10px",
                        fontSize: "18px",
                      },
                    },
                  ],
                },
              ]}
              triggerProps={{
                onMouseEnter: () => {
                  loadReturnOrders();
                },
              }}
              triggerStyle={{
                fontSize: "13px",
                color: "#1A202C",
              }}
            />

            {!orderData.parentOrderId && (
              <GaraazInfoPopover
                triggerLabel="CHILDREN"
                groups={[
                  {
                    subgroups: [
                      {
                        title: "Child Orders",
                        items:
                          CBOOrders.length > 0
                            ? CBOOrders?.map((order: any) => ({
                                key: "Order No",
                                value: order.orderNo,
                                copyable: true,
                                onClick: () => {
                                  redirectToOrderPage(order?.orderNo);
                                },
                                itemStyle: {
                                  cursor: "pointer",
                                  marginLeft: "-1px",
                                  marginBottom: "15px",
                                },
                              }))
                            : [
                                {
                                  value: "No Child Orders",
                                  itemStyle: {
                                    marginLeft: "-1px",
                                  },
                                },
                              ],
                        subgroupTitleStyle: {
                          marginLeft: "-10px",
                          fontSize: "20px",
                        },
                      },
                    ],
                  },
                ]}
                triggerProps={{
                  onMouseEnter: () => {
                    loadCBOOrders();
                  },
                }}
                triggerStyle={{
                  fontSize: "13px",
                  color: "#1A202C",
                }}
              />
            )}

            {(parentOrder?.orderNo ||
              (hasEnquiryRoot && enquiryOrder?.orderNo)) && (
              <GaraazInfoPopover
                triggerLabel={OrderPopoverLabels.PARENT}
                triggerStyle={{
                  fontSize: "13px",
                  color: "#1A202C",
                }}
                groups={[
                  {
                    subgroups: [
                      ...(parentOrder?.orderNo
                        ? [
                            {
                              title: OrderPopoverLabels.PARENT_ORDER_NO,
                              items: [
                                {
                                  value: parentOrder.orderNo,
                                  key: "parentOrderNo",
                                  copyable: true,
                                  onClick: () => {
                                    redirectToOrderPage(parentOrder.orderNo);
                                  },
                                  itemStyle: {
                                    cursor: "pointer",
                                    marginLeft: "-1px",
                                    fontSize: "14px",
                                  },
                                },
                              ],
                              subgroupTitleStyle: {
                                marginLeft: "-10px",
                                fontSize: "20px",
                              },
                            },
                          ]
                        : []),

                      ...(hasEnquiryRoot && enquiryOrder?.orderNo
                        ? [
                            {
                              title: OrderPopoverLabels.ENQUIRY_NO,
                              items: [
                                {
                                  value: enquiryOrder.orderNo,
                                  key: "enquiryOrderNo",
                                  copyable: true,
                                  onClick: () => {
                                    redirectToOrderPage(enquiryOrder.orderNo);
                                  },
                                  itemStyle: {
                                    cursor: "pointer",
                                    marginLeft: "-1px",
                                    fontSize: "14px",
                                  },
                                },
                              ],
                              subgroupTitleStyle: {
                                marginLeft: "-10px",
                                fontSize: "20px",
                              },
                            },
                          ]
                        : []),
                    ],
                  },
                ]}
              />
            )}

            {(invoiceInfo?.invoiceNo ||
              supplierInvoiceInfo.some((item: any) => item?.invoiceNo) ||
              deliveryInvoiceInfo?.invoiceNo ||
              challanInfo?.challanNo ||
              supplierChallanInfo.some((item: any) => item?.challanNo) ||
              (orderData?.creditNotes?.length ?? 0) > 0) && (
              <InvoicePopver
                copierKeys={["invoiceNo", "challanNo", "creditNoteNo"]}
                Invoices={[
                  invoiceInfo,
                  ...(deliveryInvoiceInfo?.invoiceNo
                    ? [deliveryInvoiceInfo]
                    : []),
                  ...supplierInvoiceInfo,
                ]}
                Challans={[challanInfo, ...supplierChallanInfo]}
                CreditNotes={orderData?.creditNotes ?? []}
                voidedInvoices={orderData?.voidedInvoices ?? []}
                canVoidInvoice={
                  userDetails.userSubType === Roles.HEAD_OF_OPERATIONS
                }
                canRegenerateInvoice={
                  userDetails.userSubType === Roles.HEAD_OF_OPERATIONS &&
                  orderStatus !== OrderStatus.DISPATCHED &&
                  orderStatus !== OrderStatus.DELIVERED &&
                  !orderData?.invoiceInfo?.invoiceNo &&
                  activesupplierOrderStatus?.orderStatus ===
                    OrderStatus.READY &&
                  isSupplierInvoicePresent
                }
                onRegenerateInvoice={handleRegenerateInvoice}
                orderStatus={orderStatus}
                orderNo={orderData.orderNo}
                onVoidSuccess={refetchAllOrders}
              >
                <InvoicePopoverTrigger
                  invoiceStatus={invoiceInfo.invoiceStatus}
                ></InvoicePopoverTrigger>
              </InvoicePopver>
            )}
            <Box>
              <Text fontWeight={"bold"} color={"#1A202C"}>
                HANDLER
              </Text>
              <Text
                color="teal.600"
                textTransform={"uppercase"}
                fontWeight={"semibold"}
                fontSize={"x-small"}
              >
                {`${orderHandlerName}`}
              </Text>
            </Box>
          </Box>
        </>
      )}

      <GaraazCollectPaymentModal
        auth={{ authToken: authorizationAPItoken }}
        isOpen={isCollectPaymentModalOpen}
        onClose={handleCloseCollectPaymentModal}
        orderDetails={paymentCollectionDetail}
        onCollectPayment={services.receivePayment}
        title="Receive Payment"
        collector={{
          id: userDetails?._id,
          firstName: userDetails?.firstName,
          lastName: userDetails?.lastName,
          collectedBy: CollectedBy.GARAAZ,
        }}
        selectPlaceholder="Select Mode of Payment"
        maxNotesLength={500}
        onPaymentSuccess={async () => {
          await refetchAllOrders();
        }}
        paymentModes={[
          {
            value: PaymentMode.UPI,
            label: `${PaymentMode.UPI} (preferred)`,
          },
          {
            value: PaymentMode.ADVANCE_PAYMENT,
            label: PaymentMode.ADVANCE_PAYMENT,
            prefix: "💰",
          },
        ]}
      />
    </HStack>
  );
};

export default GaraazOrderComponentFooter;
